
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { UserSubscriptions } from "@/components/subscriptions/UserSubscriptions";
import { BillsTable } from "@/components/subscriptions/BillsTable";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLocation } from "react-router-dom";

const MySubscriptions = () => {
  const [clientName, setClientName] = useState<string>("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isRestricted = searchParams.get('restricted') === 'true';

  useEffect(() => {
    const fetchClientName = async () => {
      try {
        const {
          data: {
            user
          }
        } = await supabase.auth.getUser();
        if (!user) return;
        const userEmail = user.email;
        if (!userEmail) return;
        const {
          data: schoolUser
        } = await supabase.from('school_users').select('school_id').eq('email', userEmail).maybeSingle();
        if (!schoolUser) return;
        const {
          data: clientData
        } = await supabase.from('clients').select('nama_sekolah').eq('school_id', schoolUser.school_id).maybeSingle();
        if (clientData) {
          setClientName(clientData.nama_sekolah);
        }
      } catch (error) {
        console.error('Error fetching client name:', error);
      }
    };
    fetchClientName();
  }, []);

  // Render a simpler layout for restricted access
  if (isRestricted) {
    return (
      <div className="min-h-screen w-full bg-gray-100 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold" style={{
              color: "#008169"
            }}>
              Manage Your Subscriptions
            </h1>
            {clientName && <p className="text-lg text-gray-600 mt-1">
              {clientName}
            </p>}
          </div>
          
          <div className="rounded-lg shadow-sm bg-white">
            <Tabs defaultValue="subscriptions" className="w-full">
              <TabsList className="border-b border-gray-200 w-full rounded-none h-auto p-0">
                <div className="px-6 pt-4">
                  <TabsTrigger value="subscriptions" className="data-[state=active]:border-b-2 data-[state=active]:border-teal-600 data-[state=active]:text-teal-600 rounded-none border-b-2 border-transparent px-4 py-2 bg-transparent">
                    Subscriptions
                  </TabsTrigger>
                  <TabsTrigger value="bills" className="data-[state=active]:border-b-2 data-[state=active]:border-teal-600 data-[state=active]:text-teal-600 rounded-none border-b-2 border-transparent px-4 py-2 bg-transparent">
                    Bills
                  </TabsTrigger>
                </div>
              </TabsList>
              <TabsContent value="subscriptions" className="p-6 bg-transparent">
                <UserSubscriptions />
              </TabsContent>
              <TabsContent value="bills" className="p-6">
                <BillsTable />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }

  // Original layout with sidebar for normal access
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AppSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-6">
              <h1 className="text-3xl font-bold" style={{
                color: "#008169"
              }}>
                My Subscriptions
              </h1>
              {clientName && <p className="text-lg text-gray-600 mt-1">
                {clientName}
              </p>}
            </div>
            
            <div className="rounded-lg shadow-sm bg-transparent">
              <Tabs defaultValue="subscriptions" className="w-full bg-transparent">
                <TabsList className="border-b border-gray-200 w-full rounded-none bg-transparent h-auto p-0">
                  <div className="px-6 pt-4">
                    <TabsTrigger value="subscriptions" className="data-[state=active]:border-b-2 data-[state=active]:border-teal-600 data-[state=active]:text-teal-600 rounded-none border-b-2 border-transparent px-4 py-2 bg-transparent">
                      Subscriptions
                    </TabsTrigger>
                    <TabsTrigger value="bills" className="data-[state=active]:border-b-2 data-[state=active]:border-teal-600 data-[state=active]:text-teal-600 rounded-none border-b-2 border-transparent px-4 py-2 bg-transparent">
                      Bills
                    </TabsTrigger>
                  </div>
                </TabsList>
                <TabsContent value="subscriptions" className="p-6 bg-transparent">
                  <UserSubscriptions />
                </TabsContent>
                <TabsContent value="bills" className="p-6">
                  <BillsTable />
                </TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};
export default MySubscriptions;
